import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

jQuery(function ($) {
  // click image thumb product - single product
  const wpg__image = $(".wpg__image");
  wpg__image.find("a").on("click", function (e) {
    e.preventDefault();
    $(this).next(".image-popup").trigger("click");
  });
  const wpg__thumb = $(".wpg__thumb");
  wpg__thumb.find("a").on("click", function (e) {
    e.preventDefault();
  });
  // Cap nhat gio hang khi bam tang giam so luong
  if (!$("body").hasClass("woocommerce-cart")) return;
  let timeout;
  $(".woocommerce").on("change", "input.qty", function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      $("[name='update_cart']").prop("disabled", false).trigger("click");
      setTimeout(function () {
        window.location.reload();
      }, 600);
    }, 300);
  });
  // End Cap nhat gio hang khi bam tang giam so luong
});
// js button quantity
jQuery(document).ready(function () {
  jQuery(".quantity").on("click", ".plus", function (e) {
    var inputQty = jQuery(this).prev("input.qty");
    var val = parseInt(inputQty.val());
    inputQty.val(val + 1).change();
  });
  jQuery(".quantity").on("click", ".minus", function (e) {
    var inputQty = jQuery(this).next("input.qty");
    var val = parseInt(inputQty.val());
    if (val > 0) {
      inputQty.val(val - 1).change();
    }
  });
});
jQuery(document).ajaxComplete(function () {
  jQuery(".quantity")
    .off("click", ".plus")
    .on("click", ".plus", function (e) {
      var inputQty = jQuery(this).prev("input.qty");
      var val = parseInt(inputQty.val());
      inputQty.val(val + 1).change();
    });
  jQuery(".quantity")
    .off("click", ".minus")
    .on("click", ".minus", function (e) {
      var inputQty = jQuery(this).next("input.qty");
      var val = parseInt(inputQty.val());
      if (val > 1) {
        inputQty.val(val - 1).change();
      }
    });
});
jQuery(document).on("yith_wcan_ajax_filtered", function () {});
// change text btn filter plugin
jQuery(document).ready(function () {
  jQuery(".apply-filters").text("LỌC");
  jQuery("button.btn.btn-primary.yith-wcan-filters-opener").text("Lọc");
  jQuery(".apply-filters.main-modal-button").text("Hiển thị kết quả");
  jQuery(".filters-container .clear-selection").text("Xoá tất cả");
});
// xoa dau ngoc item-count
jQuery(document).ready(function ($) {
  function removeBrackets() {
    $(".item-count").each(function () {
      var $this = $(this);
      var text = $this.text();
      if (text.includes("(")) {
        $this.text(text.replace(/[()]/g, ""));
      }
    });
  }
  removeBrackets();
  $(document).on("yith_wcan_ajax_filtered yith_wcan_init", function () {
    removeBrackets();
  });
  var observer = new MutationObserver(function (mutations) {
    removeBrackets();
  });
  $(".yith-wcan-filters").each(function () {
    observer.observe(this, { childList: true, subtree: true });
  });
});
